import React from 'react';
import AppLayout from '../components/AppLayout';
import { useNavigate } from 'react-router-dom';
import { Button, Result } from 'antd';

export default function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <>
      <AppLayout />
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Button type="primary" onClick={() => navigate('/hearing')}>
            Back Home
          </Button>
        }
      />
    </>
  );
}
